// enhancing this util from Splitter module;
// may be more units can be supported incrementally.
export function convertCSSSizeToNumber(size: number | string | undefined): number {
  if (typeof size === 'string') {
    const matches = /^(\d*\.\d+|\d+)(px|rem)$/.exec(size);
    if (matches !== null) {
      switch (matches[2]) {
        case 'px':
          return parseFloat(matches[1]);
        case 'rem':
          const retValue =
            parseFloat(matches[1]) *
            parseFloat(getComputedStyle(document.documentElement).fontSize);
          return isNaN(retValue) ? 0 : retValue;
      }
    }
  } else if (typeof size === 'number') {
    return size;
  }
  return 0;
}

export * from './getScrollbarSize';
